import { render, staticRenderFns } from "./NavigatorWork.vue?vue&type=template&id=2938c7e3"
import script from "./NavigatorWork.vue?vue&type=script&lang=js"
export * from "./NavigatorWork.vue?vue&type=script&lang=js"
import style0 from "./NavigatorWork.vue?vue&type=style&index=0&id=2938c7e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports